import { render, staticRenderFns } from "./my_scores.vue?vue&type=template&id=62826afe&scoped=true"
import script from "./my_scores.vue?vue&type=script&lang=js"
export * from "./my_scores.vue?vue&type=script&lang=js"
import style0 from "./my_scores.vue?vue&type=style&index=0&id=62826afe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62826afe",
  null
  
)

export default component.exports